import React, {useEffect, useState} from "react";

const getFlag = (locale) => {
    return new Promise((resolve, reject) => {
        import('../flags/' + locale + '.png').then((image) => {
            resolve(image);
        }).catch(e => {
            let localeParts = locale.split('_');
            if(localeParts.length > 1){
                getFlag(localeParts[0]).then(resolve, reject);
            }else{
                getFlag("unknown").then(resolve, reject);
            }
        });
    });
}
export default function ({locale, style}){
    const [image, setImage] = useState(null);

    useEffect(() => {
        let isCancelled = false;
        getFlag(locale).then((image) => {
            if(!isCancelled){
                setImage(image.default);
            }
        }, () => {});
        return () => {
            isCancelled = true;
        }
    });

    if(image === null){
        return <img alt={""} style={{...style, height: 35}}/>
    }
    return <img src={image} alt={locale} style={style}/>
}